import axios_auth from '@/axios_auth'
import axios_lpp from "@/axios_lpp";
import axios from '@/axios'
import EventBus from '@/EventBus'
import axios_node_backend from "@/axios_node_backend";
import axios_lpn from "../axios_lpn";

export default {
    data(){
      return{
          nodebackend_axios_basic : btoa('node-api-master:Mis@2020'),//.toString('base64'),
          permission_id: 629
      }
    },
    methods: {
        getLocalItem(){
            let localItem = localStorage.getItem('svea_emp')
            localItem = JSON.parse(localItem)
            return localItem
        },
        refreshToken () {
            let formData = {}
            let localItem = this.getLocalItem()
            if (localItem) {
                formData = {
                    username: localItem.user_id,
                    refresh_token: localItem.refreshToken,
                    time_available: 14400
                }
            } else {
                formData = {
                    username: '',
                    refresh_token: '',
                    time_available: 14400
                }
            }

            return axios_lpp.post('SecureApi/RefreshToken', JSON.stringify(formData))
                .then(res => {
                    return res.data
                })
                .catch(error => {
                    console.log(error)
                    this.$router.replace('/login')
                    return 'error'
                })
        },
        setAuthHeader() {
            let localItem = localStorage.getItem('svea_emp')
            localItem = JSON.parse(localItem)
            if (localItem) {
                // console.log('header is set!!')
                axios.defaults.headers.common['Authorization'] = 'Bearer '+localItem.token
            } else {
                delete axios.defaults.headers.common['Authorization']
            }
            return true
        },
        logout() {
            delete axios.defaults.headers.common['Authorization']
            localStorage.removeItem('svea_emp')
            EventBus.$emit('set_navigation', {title:'Service Excellence'})
            return this.$router.replace('/login')
        },
        async getPermissionLMIS(username){
            let result = []
            if(username) {
                try {
                    const uri = 'master/checkPermissionLMIS'
                    const result_json = await axios_node_backend.post(uri,
                        { username: username, parent_id: this.permission_id },
                        {
                            headers: {
                                'Authorization': 'Basic '+ this.nodebackend_axios_basic,
                                "Content-Type":"application/json"
                            }
                        }
                    )
                    if (result_json.data.status == 'success') {
                        result = [...result_json.data.result]
                    }
                } catch (err) {
                    console.log(err.message)
                }
            }
            return result
        },
        async checkPermission(permissionCode, accessType = 'CAN_ACCESS') {
            let allowed = false
            const localItem = this.getLocalItem()
            const permissionItem = await this.getPermissionLMIS(localItem.user_id)
            if (permissionItem) {
                const permissionFind = permissionItem.find(item => {
                    return item.SECRET_ID === permissionCode && item[accessType] === 1
                })
                if(!Object.is(permissionFind, undefined)){
                    allowed = true
                }
                return allowed
            } else {
                return allowed
            }
        },
        gotoRoute(route_name, params, callFn) {

            if (callFn && callFn.hasOwnProperty('nextFn')) {
                callFn.nextFn.forEach((nfn) => {
                    this[nfn.fnName](nfn.data)
                })

            }
            if (params && params.hasOwnProperty('external_link')) {
                window.open(route_name, params.hasOwnProperty('use_tab') ? '_blank' : '_self')
                return true
            } else {
                //ตรวจสอบ redirect ซ้ำหน้าเดิม
                if (this.$route.name != route_name) {
                    if (params && params.hasOwnProperty('use_tab')) {
                        let routeData = this.$router.resolve({name: route_name, query: params})
                        window.open(routeData.href, '_blank')
                        return true
                    } else {
                        return this.$router.push({name: route_name, query: params})
                    }
                } else {
                    //fix router duplicate แล้วมันไม่ยอม redirect ไป
                    if (this.$route.query != params) {
                        this.$router.push({name: route_name, query: params})
                        this.$router.go()
                    }
                }
            }
        },
        async clickSaved(params){
           const data = {
               username : this.getLocalItem().user_id,
               menu_id : params.menu_id
           }
            try {
                const uri = '/insertLogMenuAccess'
                await axios.post(uri, data)
            } catch (err) {
                console.log(err.message)
            }
        },
        async GetTokenLoginSystem(username,pSystemId,pAuthApi){
            let result = []
            if(username && pSystemId && pAuthApi) {
                try {
                    const systemId = pSystemId;
                    const AuthApi = pAuthApi;
                    const uri = 'ServerAuthen/CreateTokenLogin'
                    const result_json = await axios_lpn.post(uri,
                        {
                            systemId: systemId
                            ,username: username
                            ,outputType: 'api'
                            ,urlTarget: ''
                        },
                        {
                            headers: {
                                'Authorization': 'Basic '+ AuthApi,
                                "Content-Type":"application/json"
                            }
                        }
                    )


                    if (result_json.data.status == 'success') {
                        result = result_json.data.TokenID;
                    }else{
                        //console.log(result_json);
                        result = false;
                    }
                } catch (err) {
                    console.log(err.message)
                }
            }
            return result
        },
        async GetTokenLoginLPPSystem(username){
            let result = []
            if(username) {
                try {
                    const systemId = '05FE4674-740F-4D78-964A-1744BEEF8097';
                    const usernameAuth = "ServiceExcellenceLPP@system2025";
                    const passwordAuth = "gR7^Pq2!xF9@bM4#tV6$Zc1&Lh8*Ws";

                    const AuthApi = btoa(`${usernameAuth}:${passwordAuth}`);
                    const uri = 'ServerAuthen/CreateTokenLogin'
                    const result_json = await axios_lpp.post(uri,
                        {
                            systemId: systemId
                            ,username: username
                            ,outputType: 'api'
                            ,urlTarget: ''
                        },
                        {
                            headers: {
                                'Authorization': 'Basic '+ AuthApi,
                                "Content-Type":"application/json"
                            }
                        }
                    )

                    // console.log('result_json',result_json);
                    
                    if (result_json.data.status == 'success') {
                        result = result_json.data.TokenID;
                    }else{
                        //console.log(result_json);
                        result = false;
                    }
                } catch (err) {
                    console.log(err.message)
                }
            }
            return result
        },
    }
}



// Retrieve the object from storage
//var retrievedObject = localStorage.getItem('testObject');
//console.log('retrievedObject: ', JSON.parse(retrievedObject));

